import { render, staticRenderFns } from "./shengjishuoming.vue?vue&type=template&id=cbdc3ace&scoped=true&"
import script from "./shengjishuoming.vue?vue&type=script&lang=js&"
export * from "./shengjishuoming.vue?vue&type=script&lang=js&"
import style0 from "./shengjishuoming.vue?vue&type=style&index=0&id=cbdc3ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdc3ace",
  null
  
)

export default component.exports